import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';
import {
  CustomQuery
} from '@vue-storefront/core';
import { useApiError } from '../useApiError';
export const usePreviewOrder = (id: string): any => {
  // Loads context used to call API endpoint
  const context = useVSFContext();
  const { set: setError } = useApiError();
  // console.log("usePreviewOrdercontext---------", context.useApiError);

  // Shared ref holding the response from the API
  const result = sharedRef(null, `usePreviewOrder-${id}`);

  // Shared ref indicating whether any method is waiting for the data from the API
  const loading = sharedRef(false, `usePreviewOrder-loading-${id}`);

  // Shared ref holding errors from the methods
  const error = sharedRef({ load: null, code: -1 }, `usePreviewOrder-error-${id}`);

  // Method to call an API endpoint and update `result`, `loading` and `error` properties
  const preview = async (params: CustomQuery) => {
    try {
      loading.value = true;
      const res = await context.$xbuy.api.orderPreview(params);
      // context.useApiError.set(res);
      // console.log('预览订单----------------', res);
      // console.log(' res.data?.errs?.[0]', res.data?.errs);
      if (res && res.code === 0) {
        if (res.data?.errs?.length && typeof res.data?.errs?.[0] === 'string') {
          const errs = JSON.parse(res.data?.errs?.[0]);
          res.data.errs[0] = errs;
          result.value = res.data;
          setError({ message: (errs.title || '') + errs.message, code: errs.code });
        } else if (res.data?.errs?.length && typeof res.data?.errs?.[0] === 'object') {
          const errs = (res.data?.errs?.[0]);
          const err = res.data?.errs.find(err => err.code === 3013);
          if (!err) {
            // console.log('不渲染订单');
            result.value = res.data;
          }
          if (errs.code !== 3014 && errs.code !== 7108) {
            setError({ message: (errs.title || '') + errs.message, code: errs.code });
          }
        } else {
          result.value = res.data;
          error.value.code = -1;
          error.value.load = null;
        }
      } else {
        error.value.code = res.code;
        error.value.load = res.message;
        result.value = null;
        setError({ message: res.message, code: res.code });
      }
    } catch (err) {
      error.value.load = err;
      error.value.code = 1000;
      result.value = null;
    } finally {
      loading.value = false;
    }
  };

  return {
    preview,
    preorder: computed(() => result.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value)
  };
};
